import { gql } from '@apollo/client';

export const DRIVER_LEARNING_CENTER_FAQ_NODE_FIELDS = gql`
  fragment DriverLearningCenterFaqNodeFields on DriverLearningCenterFaqNodeType {
    id
    nodeType
    parentId
    slug
    titleZh
    titleEn
    titleEs
    questionZh
    questionEn
    questionEs
    answerZh
    answerEn
    answerEs
    sortOrder
    isEnabled
    createdBy
    createdByName
    updatedBy
    updatedByName
    updatedAt
    createdAt
  }
`;

export const GET_DRIVER_LEARNING_CENTER_FAQ_NODES_WITH_PAGINATION = gql`
  query GetDriverLearningCenterFaqNodesWithPagination($request: DriverLearningCenterFaqPageRequestInput!) {
    getDriverLearningCenterFaqNodesWithPagination(request: $request) {
      content {
        ...DriverLearningCenterFaqNodeFields
      }
      pageNum
      pageSize
      total
    }
  }
  ${DRIVER_LEARNING_CENTER_FAQ_NODE_FIELDS}
`;
